<template>
  <div class="unitListWrapper">
    <div class="currVersion">
      当前版本：<span>{{ gradeNameMap[params.gradeId] }}</span><span>{{ params.termId == 1 ? '(上)' : '(下)' }}</span><span>{{
        decodeURIComponent(params.editionName) }}</span>
    </div>
    <div class="nav-box" v-if="specialDataList && specialDataList.length">
      <div class="nav-item" :class="{ active: navType == 'sync' }" @click="handleNavType('sync')">同步教学</div>
      <div class="nav-item" :class="{ active: navType == 'major' }" @click="handleNavType('major')">专项提升</div>
    </div>
    <div v-else style="height: 20px;"></div>
    <div class="container" :class="{ 'is-multiple-codes': pageType == 'multipleCodes' }" @scroll="handleScroll"
      ref="container">
      <ContentBox :data="navType == 'sync' ? syncDataList : specialDataList" :trackData="trackData"
        v-if="pageType == 'multipleCodes'" :qrCodeTag="qrCodeTag"></ContentBox>
      <div v-else id="navContent1" class="navContent">
        <div v-for="(unit, index) in resetCurrEditionObj()" :key="index">
          <ul class="unitList">
            <h1 v-html="unit.name"></h1>
            <li v-for="(course, index1) in unit.childrens" :key="index1">
              <div v-if="course.mark == '学' || course.mark == '复习'">
                <h1
                  v-if="(course.childrens.tongbu.childrens.length > 0 || course.childrens.tigao.childrens.length > 0 || course.childrens.lianxi.childrens.length > 0)"
                  @click="toggleCourse($event)"><span v-html="course.name"></span><i @click="toggleCourse2($event)"></i>
                </h1>
                <h1 v-else class="colorGray" @click="lockTips" v-html="course.name"></h1>
                <div class="switchVideoMenu"
                  v-if="(course.childrens.tongbu.childrens.length > 0 || course.childrens.tigao.childrens.length > 0 || course.childrens.lianxi.childrens.length > 0)">
                  <ul class="videoMenu">
                    <li v-for="(lession, index2, i) in course.childrens" :key="i"
                      :class="{ hover: (i == 0 && course.childrens.tongbu.childrens.length > 0) || (i == 1 && course.childrens.tongbu.childrens.length == 0 && course.childrens.tigao.childrens.length > 0) || (i == 2 && course.childrens.tongbu.childrens.length == 0 && course.childrens.tigao.childrens.length == 0 && course.childrens.lianxi.childrens.length > 0) }"
                      v-if="lession.childrens.length > 0" @click="switchVideoMenu($event, i, lession.name)">
                      <!-- <i class="playIco" v-if="index2!='lianxi'"></i>
                            <i class="lianxi" v-else></i> --> {{ lession.name }}
                    </li>
                  </ul>
                  <div class="videoItem" v-for="(lession, index2, i) in course.childrens" :key="i"
                    :class="{ hover: (i == 0 && course.childrens.tongbu.childrens.length > 0) || (i == 1 && course.childrens.tongbu.childrens.length == 0 && course.childrens.tigao.childrens.length > 0) || (i == 2 && course.childrens.tongbu.childrens.length == 0 && course.childrens.tigao.childrens.length == 0 && course.childrens.lianxi.childrens.length > 0) }"
                    v-if="lession.childrens.length > 0">
                    <div v-if="lession.name != '课后练习'">
                      <ul v-for="(cart, index3) in lession.childrens">
                        <h1 class="type-name" @click="toggleCart($event)">{{ cart.name }}<i
                            @click="toggleCart2($event)"></i></h1>
                        <li v-for="(book, index4) in cart.childrens" :key="index4"
                          :class="{ currColor: (currSubCourseName && currVideoId == book.videoCode && currVideoName == book.showName && currSubCourseName == course.name) || (!currSubCourseName && currVideoId == book.videoCode && currVideoName == book.showName) }"
                          @click="goPlayVideo(book.videoCode, book.showName)">
                          <i class="icoPlay"></i><span v-text="book.showName"></span>
                        </li>
                      </ul>
                    </div>
                    <div v-else>
                      <ul>
                        <li v-for="(cart, index3) in lession.childrens"
                          @click="goExam(currObj.subjectId, cart.name, cart.contentPos, cart.mark)"
                          :class="{ pt0: index3 == 0 }"><i class="icoLianxi2"></i>{{ cart.name }}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="loading" class="loading">
        <van-loading size="24px" vertical>加载中...</van-loading>
      </div>
      <div class="empty-msg"
        v-if="!resetCurrEditionObj().length && ((navType == 'sync' && !syncDataList.length) || (navType == 'major' && !specialDataList.length))">
        <img src="@/assets/error-icon.png" alt="">
        资源已过期
      </div>
    </div>
    <div class="btnTop" @click="jumpTop" v-if="backTopShow"></div>
    <div class="mark" v-if="!canShowContent">
      <van-loading size="24px" vertical v-if="userLoading">加载中...</van-loading>
    </div>
    <guide-info v-if="showGuideInfo" :guide-qr-code="guideQrCode"></guide-info>
    <error-msg v-if="errorMsg" :error-msg="errorMsg"></error-msg>
    <login-box v-if="showLogin" @login="handleLogin"></login-box>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import './index.scss'
import { getResourceContent, getBookUnitContent } from "@/axios/bookUnit";
import { getGuideInfoByUnionId } from "@/axios/auth";
import { getLocation, goWxAuth } from "@/utils/wx";
import { getUrlCode, getUrlState } from "@/utils/tools";
import GuideInfo from './components/GuideInfo';
import ErrorMsg from './components/ErrorMsg';
import LoginBox from './components/LoginBox';
import ContentBox from './components/ContentBox';


const gradeNameMap = {
  1: '一年级',
  2: '二年级',
  3: '三年级',
  4: '四年级',
  5: '五年级',
  6: '六年级',
  7: '七年级',
  8: '八年级',
  9: '九年级'
};
const subjectNameMap = {
  1: '语文',
  2: '数学',
  3: '英语',
  7: '生物',
  8: '物理',
  9: '化学',
  5: '历史',
  6: '地理',
  32: '道德与法治'
};
const termNameMap = {
  1: '上册',
  2: '下册'
};
export default {
  components: {
    GuideInfo,
    ErrorMsg,
    LoginBox,
    ContentBox
  },
  data() {
    return {
      gradeNameMap,
      backTopShow: false,
      currSubCourseName: '',
      currVideoId: '',
      params: {},
      tutorialName: '',
      unitList: [],
      scrollTop: 0,
      loading: true,
      userLoading: true,
      canShowContent: false,
      errorMsg: '',
      showGuideInfo: false,
      guideQrCode: '',
      showTime: 0,
      timer: null,
      trackData: {
        pageId: 10001,
        pageName: '课程列表'
      },
      showLogin: false,
      navType: this.$route.query.nav || 'sync',
      pageType: this.$route.query.type || '',
      syncDataList: [],
      specialDataList: []
    };
  },
  created() {
    this.params = { ...this.$route.query, controllFlag: false };
    const { gradeId, termId, editionName, subjectId, type, subjectName, gradeName } = this.$route.query;
    this.trackData.submitDetail = `${subjectNameMap[subjectId]}${gradeNameMap[gradeId]}${decodeURIComponent(editionName)}${termNameMap[termId]}`
    if (type == 'multipleCodes') {
      this.getBookUnitContent({
        subjectName: decodeURIComponent(subjectName),
        gradeName: decodeURIComponent(gradeName),
      });
    } else {
      this.getResourceContent(this.params);
    }
  },
  computed: {
    ...mapState({
      unionId: state => state.auth.unionId
    }),
    qrCodeTag() {
      return decodeURIComponent(this.$route.query.qrCodeTag || '');
    }
  },
  watch: {
    unionId: {
      handler(newVal) {
        if (newVal) {
          ktbj.setUnionId(newVal);
        }
      },
      immediate: true
    },
  },
  mounted() {
    this.handleAuth();
  },
  beforeDestroy() {
    this.handleDestroy()
  },
  activated() {
    if (this.canShowContent) {
      this.reportPageExpose()
      this.backScroll()
    }
  },
  deactivated() {
    sessionStorage.setItem('scrollTop', this.scrollTop);
    // 离开页面清理定时器/滚动状态
    this.handleDestroy()
  },
  methods: {
    handleNavType(type) {
      this.navType = type;
      this.$refs.container.scrollTop = 0;
    },
    handleCodePosition() {
      const qrCodeTag = this.qrCodeTag;
      if (!qrCodeTag) return;
      const target = document.getElementById(qrCodeTag);
      if (!target) return;
      const offsetTop = target.offsetTop;
      this.$refs.container.scrollTop = offsetTop - 200;
    },
    getBookUnitContent(params) {
      this.loading = true;
      const p1 = getBookUnitContent({ ...params, type: 'MAJOR' });
      const p2 = getBookUnitContent({ ...params, type: 'SYNC' });

      Promise.allSettled([p1, p2]).then(([resultMajor, resultSync]) => {
        this.loading = false;
        // 处理MAJOR结果
        if (resultMajor.status === 'fulfilled') {
          const resMajor = resultMajor.value;
          if (resMajor.errcode && resMajor.errcode !== 0) {
            this.$toast(resMajor.errmsg || '网络错误，请重试~');
          } else {
            this.specialDataList = (resMajor.data || {}).childNodes || [];
          }
        }

        // 处理SYNC结果
        if (resultSync.status === 'fulfilled') {
          const resSync = resultSync.value;
          if (resSync.errcode && resSync.errcode !== 0) {
            this.$toast(resSync.errmsg || '网络错误，请重试~');
          } else {
            this.syncDataList = (resSync.data || {}).childNodes || [];
          }
        }

        this.$nextTick(() => {
          this.handleCodePosition();
        });
      }).catch(err => {
        this.loading = false;
      });
    },
    handleDestroy() {
      this.destroyTimer()
      if (this.showTime) {
        ktbj.track('PAGE_EXIT', { ...this.trackData, duration: Date.now() - this.showTime });
      }
    },
    handleLogin() {
      goWxAuth()
    },
    reportPageExpose() {
      this.showTime = Date.now()
      ktbj.track('PAGE_EXPOSE', this.trackData);
      this.reportPageView();
    },
    // 每隔10s上报一次PAGE_VIEW事件，使用setTimeout
    reportPageView() {
      this.destroyTimer()
      this.timer = setTimeout(() => {
        const now = Date.now()
        ktbj.track('PAGE_VIEW', { ...this.trackData, duration: now - this.showTime });
        this.showTime = now
        this.reportPageView();
      }, 10000);
    },
    destroyTimer() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
    },
    handleAuth() {
      // 没有unionId并且没有code
      if (!this.unionId && !getUrlCode()) {
        this.showLogin = true
        this.userLoading = false
        return
      }
      // 没有unionId但是有code
      if (!this.unionId && getUrlCode()) {
        // 获取unionId
        this.$store.dispatch({
          type: 'getUnionId',
          meta: { jsCode: getUrlCode(), appCode: 'yxp_yuexiangsai' }
        }).then((res) => {
          if (res.errcode !== 0) {
            throw new Error(res.errmsg);
          }
          this.handleGuide();
        }).catch(err => {
          this.userLoading = false;
          this.errorMsg = err.errmsg || '服务授权失败，请重新授权~';
        });
        return
      }
      this.handleGuide();
    },
    handleGuide() {
      if (!this.unionId) {
        this.userLoading = false;
        this.errorMsg = '服务授权失败，请重新授权~';
        return
      }
      getGuideInfoByUnionId({ unionId: this.unionId, sourceType: 'COURSE_NOTE' }).then(res => {
        if (res.errcode !== 0) {
          throw new Error(res.errmsg);
        }
        this.userLoading = false;
        const { isFriend, qrCodeUrl } = res.data || {};
        if (isFriend) {
          this.canShowContent = true
          this.reportPageExpose()
          return
        }
        if (qrCodeUrl) {
          this.showGuideInfo = true
          this.guideQrCode = qrCodeUrl
          return
        }
        this.getGuideInfoByAddress()
      }).catch(err => {
        this.userLoading = false;
        this.errorMsg = err.message || '';
      });
    },
    getGuideInfoByAddress() {
      getLocation()
        .then((res) => {
          this.userLoading = true;
          const { latitude, longitude } = res;
          getGuideInfoByUnionId({ latitude, longitude, sourceType: 'COURSE_NOTE_LOCATION', unionId: this.unionId }).then(res => {
            if (res.errcode !== 0) {
              throw new Error(res.errmsg);
            }
            this.userLoading = false;
            const { qrCodeUrl } = res.data || {}
            if (qrCodeUrl) {
              this.showGuideInfo = true
              this.guideQrCode = qrCodeUrl
              return
            }
            this.errorMsg = '未找到附近的服务老师~';
          }).catch(err => {
            this.userLoading = false;
            this.errorMsg = err.message || '未找到附近的服务老师~';
          });
        })
        .catch((e) => {
          this.errorMsg = e.errMsg || '';
        });
    },
    handleScroll(e) {
      const scrollTop = e.target.scrollTop;
      this.scrollTop = scrollTop;
      if (scrollTop > 100) this.backTopShow = true;
      else this.backTopShow = false;
    },
    jumpTop() {
      this.$refs.container.scrollTop = 0;
    },
    backScroll() {
      this.$nextTick(() => {
        this.$refs.container.scrollTop = sessionStorage.getItem('scrollTop')
        sessionStorage.removeItem('scrollTop')
      })
    },
    goPlayVideo: function (videoId, name) {
      const resourceName = videoId.replaceAll('<ID>', '').replaceAll('</ID>', '');
      ktbj.track('BUTTON_CLICK', { ...this.trackData, buttonName: name, resourceName: resourceName });
      this.$router.push({
        path: '/videoPlayer',
        query: {
          videoId: encodeURIComponent(resourceName),
          name: name,
          type: 'video'
        }
      });
    },
    toggleCart: function (e) {
      $(e.target).toggleClass("hover");
      $(e.target).parent().children("li").toggle();
    },
    toggleCart2: function (e) {
      $(e.target).parent().toggleClass("hover");
      $(e.target).parent().parent().children("li").toggle();
    },
    switchVideoMenu: function (e, i, name) {
      var n = 0;
      $(e.target).parent().children("li").each(function (k) {
        if ($(this).text().replace(/\s/g, '') == name) {
          n = k;
        }
      });
      $(e.target).parent().children("li").removeClass("hover").eq(n).addClass("hover");
      $(e.target).parent().parent().children(".videoItem").removeClass("hover").eq(n).addClass("hover");
    },
    toggleCourse: function (e) {
      var tagName = e.target.tagName;
      if (tagName == 'SPAN') {
        $(e.target).parent().toggleClass("hover");
        $(e.target).parent().next(".switchVideoMenu").toggle();
      } else {
        $(e.target).toggleClass("hover");
        $(e.target).next(".switchVideoMenu").toggle();
      }
    },
    toggleCourse2: function (e) {
      $(e.target).parent().toggleClass("hover");
      $(e.target).parent().next(".switchVideoMenu").toggle();
    },
    resetCurrEditionObj() {
      var childrens2 = this.unitList,
        newChildrens2 = [];
      if (childrens2 != undefined) {
        childrens2.forEach(function (item3, index3) { //第二层  单元
          var obj3 = {};
          obj3.name = item3.name;
          var childrens3 = item3.childrens,
            newChildrens3 = [];
          childrens3.forEach(function (item4, index4) { //第三层 阶段分类
            var obj4 = {};
            for (var k in item4) {
              if (k === 'childrens' && (item4.mark == '学' || item4.mark == '复习')) {
                var childrens4 = item4.childrens,
                  newChildrens4 = {};
                newChildrens4.tongbu = {};
                newChildrens4.tongbu.name = '同步视频';
                newChildrens4.tongbu.childrens = [];
                newChildrens4.tigao = {};
                newChildrens4.tigao.name = '同步提高';
                newChildrens4.tigao.childrens = [];
                newChildrens4.lianxi = {};
                newChildrens4.lianxi.name = '课后练习';
                newChildrens4.lianxi.childrens = [];
                childrens4.forEach(function (item5, index5) { //第四层 视频分类
                  if (item5.mark.indexOf('基础') != -1) {
                    newChildrens4.tongbu.childrens.push(item5);
                  } else if (item5.mark.indexOf('提高') != -1) {
                    newChildrens4.tigao.childrens.push(item5);
                    // } else if(item5.mark.indexOf('练习') != -1 || item5.mark.indexOf('答案') != -1) {
                  } else if (item5.mark.indexOf('练习') != -1) {
                    // newChildrens4.lianxi.childrens.push(item5);
                  } else { }
                });
                obj4[k] = newChildrens4;
              } else {
                obj4[k] = item4[k];
              }
            }
            newChildrens3.push(obj4);
          });
          //将单元总结（mark：复习） 单元达标检测（mark:练习） 单元达标检测答案（mark:答案）放在最上面
          newChildrens3.forEach(function (item5, index5) {
            if (item5.mark == '答案') {
              newChildrens3.splice(index5, 1);
              newChildrens3.splice(0, 0, item5);
            }
          });
          newChildrens3.forEach(function (item5, index5) {
            if (item5.mark == '练习') {
              newChildrens3.splice(index5, 1);
              newChildrens3.splice(0, 0, item5);
            }
          });
          newChildrens3.forEach(function (item5, index5) {
            if (item5.mark == '复习') {
              newChildrens3.splice(index5, 1);
              newChildrens3.splice(0, 0, item5);
            }
          });
          newChildrens3.forEach(function (item5, index5) {
            if (item5.mark == '目标') {
              newChildrens3.splice(index5, 1);
              newChildrens3.splice(0, 0, item5);
            }
          });
          var fuxiChildren = [];
          newChildrens3 = newChildrens3.filter(function (data) {
            return data;
          });

          obj3.childrens = newChildrens3;
          obj3.fuxiChildren = fuxiChildren;
          newChildrens2.push(obj3);
        });
      }
      return newChildrens2;
    },
    getResourceContent(params) {
      this.loading = true;
      getResourceContent({
        "headers": {
          "Accept-Encoding": "identity"
        },
        "responseHeaders": {
          "Content-Encoding": "None"
        },
        method: "GET",
        url: 'https://prelearn.youxuepai.com/ures/resource/prelearn/getContent',
        params: params
      }).then(res => {
        this.loading = false;
        if (res.errcode && res.errcode != 0) {
          this.$toast(res.errmsg || '网络错误，请重试~')
          return;
        }
        const { tutorialName = '', childrens = [] } = res.value || {}
        this.tutorialName = tutorialName
        this.unitList = childrens.filter(function (data) {
          return data.name.indexOf('绪言') == -1 && data.name.indexOf('期中') == -1 && data.name.indexOf('期末') == -1 && data.name.indexOf('测试') == -1 && data.name.indexOf('Recycle') == -1 && data.name.indexOf('Revision') == -1 && data.name.indexOf('Project') == -1;
        })
      }).catch(err => {
        this.$toast('网络错误，请重试~');
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.unitListWrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;

  .nav-box {
    display: flex;
    height: 45px;
    justify-content: space-around;

    .nav-item {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 17px;
      font-weight: 400;
      color: #676769;
      cursor: pointer;
      position: relative;

      &.active {
        font-weight: 500;
        color: #242424;

        &::after {
          content: '';
          display: block;
          width: 40px;
          height: 4px;
          background: linear-gradient(90deg, #69E09F 0%, #37C555 100%);
          border-radius: 2px;
          position: absolute;
          bottom: 5px;
          left: 13px;
        }
      }
    }
  }

  .currVersion {
    padding: 0.2rem 0.3rem;
    background-color: #fff;
    font-size: 16px;

    span {
      font-weight: bold;
      padding: 0 0.1rem 0 0;
    }
  }

  .container {
    flex: 1;
    overflow-y: scroll;
    padding: 0 0.3rem;
    margin: 0.3rem 0;

    &.is-multiple-codes {
      margin: 0;
      padding: 0;
    }

    .navContent {
      background-color: #fff;
      border-radius: 0.2rem;
    }
  }
}

.loading {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.empty-msg {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    width: 240px;
    height: 240px;
    margin-bottom: 10px;
  }
}

.type-name {
  font-size: 16px;
}

.mark {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;

  :global {
    .van-loading__text {
      font-size: 16px;
      color: #fff;
    }
  }
}
</style>
